import SecurityDashboard from "./pages/SecurityDashboard";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./assets/css/backend.css";
import "./assets/css/backend-plugin.min.css";
import "./assets/vendor/remixicon/fonts/remixicon.css";
import "./assets/vendor/line-awesome/dist/line-awesome/css/line-awesome.min.css";
import "./assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import { Dashcam } from "./pages/Dashcam";
import { Fleet } from "./pages/Fleet";
import { Simcards } from "./pages/Simcards";
import { Users } from "./pages/Users";
import Map from "./pages/Map";
import { Drivers } from "./pages/Drivers";
import { Vehicles } from "./pages/Vehicles";
import { Settings } from "./pages/Settings";
import DashboardLayout from "./components/layout/DashboardLayout";
import LoginLayout from "./components/Login/LoginLayout";

import SecurityErrorBoundary from './components/SecurityErrorBoundary';
import { LanguageProvider } from './hooks/LanguageProvider';
import Driver from "./pages/Driver";
import User from "./pages/User";
import { GroupeVehicles } from "./pages/GroupVehicule";
import HistoriqueTag from "./pages/History-tag";
import { Devices } from "./pages/Devices";
import { GroupeDevice } from "./pages/GroupeDevice";
import Help from "./pages/Help";
import Vehicle from "./pages/Vehicle";
import Device from "./pages/Device";
import NewReport from "./pages/NewReport";
import { Reports } from "./pages/Reports";
import { SnapshotPage } from "./pages/SnapshotPage";
import Report from "./pages/Report";
import { LogPositions } from "./pages/LogPositions";
import { DriverTag } from "./pages/driver-tag";
import Role from "./pages/Role";
import Profile from "./pages/Profile";
import { Permission } from "./pages/Permission";
import UserHistory from "./pages/history-user";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import HistoryVehicle from "./pages/history-vehicle";
import { POIreports } from "./pages/poi-reports";
import NewPOIreport from "./pages/new-poi-report";
import { FleetReports } from "./pages/fleet-reports";
import NewFleetReport from "./pages/new-fleet-report";
import { Ticket } from "./pages/Ticket";
import { Alarms } from "./pages/Alarms";
import Alarm from "./pages/Alarm";
import { GroupAlarms } from "./pages/Group-alarms";
import { POIs } from "./pages/pois";
import POI from "./pages/poi";
import { Notifications } from "./pages/Notification";
import Chat from "./pages/Chat";
import NotFound from "./pages/NotFound";
import Connection from "./pages/Connection";
import IButtons from "./pages/Ibutton";
import { TMSs } from "./pages/tms";
import { ThemeProvider } from "./hooks/ThemeContext";
import { Dashboard } from "./pages/Dashboard";
import Dashboard2 from "./pages/Dashboard2";
import GeofenceChecker from "./pages/Geofence-checker";
import { UserProvider } from "./context/UserContext";
import { GroupeDrivers } from "./pages/GroupDriver";
import { PositionTracking } from "./pages/position-tracking";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginForm from "./pages/Login";
import { Sites } from "./pages/Sites";

import  Programs  from "./pages/Programs";

import DriverBehaviorConfig from "./pages/DriverBehaviorConfigPage";
import NotificationCenter from "./pages/NotificationCenter";
import { Preferences } from "./pages/Preference";
import Carburant from "./pages/Carburant";
import FleetManagementDocumentation from "./components/Help/FleetManagementDocumentation ";

import "./assets/css/mobile-list-controls.css";



function App() {
  const location = useLocation();

  // Documentation développeur publique : aucun fournisseur de session n'est
  // monté sur cette route et aucune connexion à la plateforme n'est requise.
  if (location.pathname === "/api-documentation" || location.pathname === "/api-documentation/") {
    return (
      <Routes>
        <Route path="/api-documentation" element={<FleetManagementDocumentation />} />
      </Routes>
    );
  }

  const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const { user, loading } = useAuth();
    if (loading) return <div id="loading" style={{ display: "none" }}>
      <div id="loading-center">
      </div>
    </div>;
    if (!user) return <Navigate to="/login" replace />;
    return <>{children}</>;
  };

  return (
    <AuthProvider>
      <UserProvider>
        <ThemeProvider>
          <LanguageProvider>
          <SecurityErrorBoundary key={location.pathname}>
            <div className="wrapper" style={{ transition: 'width 0.3s', backgroundColor: '#fff', height: '100vh', padding: '0px' }}>
              <Routes>
                <Route path="/" element={<ProtectedRoute><DashboardLayout> <Dashboard /> </DashboardLayout> </ProtectedRoute>} />
                <Route path="/map" element={<ProtectedRoute><DashboardLayout>{<Map />}</DashboardLayout>  </ProtectedRoute>} />
                <Route path="/map/live/:immatriculation_vehicule" element={ <ProtectedRoute> <DashboardLayout> <Map /> </DashboardLayout> </ProtectedRoute> } />
                <Route path="/vehicles" element={<ProtectedRoute><DashboardLayout>{<Vehicles />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Vehicle/add" element={<ProtectedRoute><DashboardLayout>{<Vehicle />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Vehicle/edit/:id_vehicule" element={<ProtectedRoute><DashboardLayout>{<Vehicle />}</DashboardLayout> </ProtectedRoute>} />
                 <Route path="/Vehicle-new/add" element={<ProtectedRoute><DashboardLayout>{<Vehicle />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Vehicle-new/edit/:id_vehicule" element={<ProtectedRoute><DashboardLayout>{<Vehicle />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Devices" element={<ProtectedRoute><DashboardLayout>{<Devices />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Device/add" element={<ProtectedRoute><DashboardLayout>{<Device />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Device/edit/:id_device" element={<ProtectedRoute><DashboardLayout>{<Device />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/drivers" element={<ProtectedRoute><DashboardLayout>{<Drivers />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/driver" element={<ProtectedRoute><DashboardLayout>{<Driver />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/driver/:id_conducteur" element={<ProtectedRoute><DashboardLayout>{<Driver />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/group-driver" element={<ProtectedRoute><DashboardLayout>{<GroupeDrivers />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Fleet" element={<ProtectedRoute><DashboardLayout>{<Fleet />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/dashcam" element={<ProtectedRoute><DashboardLayout>{<Dashcam />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/cartes-sim" element={<ProtectedRoute><DashboardLayout>{<Simcards />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/security" element={<ProtectedRoute><DashboardLayout><SecurityDashboard /></DashboardLayout></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute><DashboardLayout>{<Users />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/User" element={<ProtectedRoute><DashboardLayout>{<User />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Ibutton" element={<ProtectedRoute><DashboardLayout>{<IButtons />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/reports" element={<ProtectedRoute><DashboardLayout>{<Reports />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/poi-reports" element={<ProtectedRoute><DashboardLayout>{<POIreports />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/new-poi-report" element={<ProtectedRoute><DashboardLayout>{<NewPOIreport />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/fleet-reports" element={<ProtectedRoute><DashboardLayout>{<FleetReports />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/new-fleet-report" element={<ProtectedRoute><DashboardLayout>{<NewFleetReport />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/snapshots" element={<ProtectedRoute><DashboardLayout>{<SnapshotPage />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/report/:id_report/:turn/:type_report/:id_dispositif" element={<ProtectedRoute><DashboardLayout>{<Report />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/new-report" element={<ProtectedRoute><DashboardLayout>{<NewReport />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/history-tag" element={<ProtectedRoute><DashboardLayout>{<HistoriqueTag />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/history-vehicle" element={<ProtectedRoute><DashboardLayout>{<HistoryVehicle />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/history-user" element={<ProtectedRoute><DashboardLayout>{<UserHistory />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Devices" element={<ProtectedRoute><DashboardLayout>{<Devices />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/help" element={<ProtectedRoute><DashboardLayout>{<Help />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/logpositions" element={<ProtectedRoute><DashboardLayout>{<LogPositions />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Connection" element={<ProtectedRoute><DashboardLayout>{<Connection />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/driver-tag" element={<ProtectedRoute><DashboardLayout>{<DriverTag />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/Settings" element={<ProtectedRoute><DashboardLayout>{<Settings />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/User/:userurlID" element={<ProtectedRoute><DashboardLayout>{<User />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/groupevehicles" element={<ProtectedRoute><DashboardLayout>{<GroupeVehicles />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/groupe-device" element={<ProtectedRoute><DashboardLayout>{<GroupeDevice />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/role" element={<ProtectedRoute><DashboardLayout>{<Role />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/role/permission/:id_user/:id_role" element={<ProtectedRoute><DashboardLayout>{<Permission />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><DashboardLayout>{<Profile />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/tickets" element={<ProtectedRoute><DashboardLayout>{<Ticket />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/alarms" element={<ProtectedRoute><DashboardLayout>{<Alarms />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/alarm/add" element={<ProtectedRoute><DashboardLayout>{<Alarm />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/alarm/edit/:id_alarme" element={<ProtectedRoute><DashboardLayout>{<Alarm />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/group-alarms" element={<ProtectedRoute><DashboardLayout>{<GroupAlarms />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/pois" element={<ProtectedRoute><DashboardLayout>{<POIs />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/poi/edit/:id_poi" element={<ProtectedRoute><DashboardLayout>{< POI />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/poi/add" element={<ProtectedRoute><DashboardLayout>{< POI />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/geofence-checker" element={<ProtectedRoute><DashboardLayout>{< GeofenceChecker />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/position-tracking" element={<ProtectedRoute><DashboardLayout>{< PositionTracking />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/position-tracking/:from_date/:to_date/:search_term" element={<ProtectedRoute><DashboardLayout>{< PositionTracking />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute><DashboardLayout>{< Notifications />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/notifications/:id_notification" element={<ProtectedRoute><DashboardLayout>{< Notifications />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/chat" element={<ProtectedRoute><DashboardLayout>{<Chat />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/chat/:id_ticket/:id_received" element={<ProtectedRoute><DashboardLayout>{<Chat />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/tms" element={<ProtectedRoute><DashboardLayout>{<TMSs />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/dash2" element={<ProtectedRoute><DashboardLayout>{<Dashboard2 />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/sites" element={<ProtectedRoute><DashboardLayout>{<Sites />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/programs/:id_site/:name" element={ <ProtectedRoute> <DashboardLayout> <Programs /> </DashboardLayout> </ProtectedRoute> } />
                <Route path="/notification-center/:id_user" element={<ProtectedRoute><DashboardLayout>{<NotificationCenter />}</DashboardLayout> </ProtectedRoute>} />
                <Route path="/preference" element={<ProtectedRoute><DashboardLayout>{<Preferences />}</DashboardLayout>{" "}</ProtectedRoute>}/>
                <Route path="/carburant" element={<ProtectedRoute><DashboardLayout>{<Carburant />}</DashboardLayout>{" "}</ProtectedRoute>}/>
                
                <Route
                  path="/driver-behavior-config/:id_user"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <DriverBehaviorConfig from="admin" />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />


                <Route
                  path="/driver-behavior-config"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <DriverBehaviorConfig from="user" />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route path="/login" element={<LoginLayout><LoginForm /></LoginLayout>} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            </SecurityErrorBoundary>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              limit={4}
            />
          </LanguageProvider>
        </ThemeProvider>
      </UserProvider>
    </AuthProvider>

  );
}

export default App;
